import React from 'react';

export function useMap<KeyType, ValueType>(
  initialMap?: Iterable<readonly [KeyType, ValueType]>
) {
  const [map, setMap] = React.useState(new Map<KeyType, ValueType>(initialMap));

  const set = React.useCallback((key: KeyType, value: ValueType) => {
    setMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.set(key, value);
      return newMap;
    });
  }, []);

  const remove = React.useCallback((key: KeyType) => {
    setMap((prevMap) => {
      const newMap = new Map(prevMap);
      newMap.delete(key);
      return newMap;
    });
  }, []);

  const reset = React.useCallback(() => {
    setMap(new Map(initialMap));
  }, [initialMap]);

  const get = React.useCallback((key: KeyType) => map.get(key), [map]);

  return [map, { set, remove, reset, get }] as const;
}
